import * as mt from "./mutation-types";

export default {
  [mt.SET_SHOW_ADMIN_TOOLBAR](state, value) {
    state.showAdminToolbar = value;
    localStorage.setItem("showAdminToolbar", JSON.stringify(value));
  },
  [mt.SET_SHOW_GLS_ADMIN](state, value) {
    state.showGlsAdmin = value;
    localStorage.setItem("showGlsAdmin", JSON.stringify(value));
  },
  [mt.SET_GLS_PAGE_PK](state, value) {
    state.pagePk = value;
  },
  [mt.SET_GLS_PAGE_REVISION_PK](state, value) {
    state.revisionPk = value;
  },
  [mt.SET_GLS_PAGE_NAME](state, value) {
    state.pageName = value;
  },
  [mt.SET_AVAILABLE_PAGE_VERSIONS](state, value) {
    state.availablePageVersions = value;
  },
  [mt.SET_EDITABLE_MODE](state, value) {
    state.editableMode = value;
  },
  [mt.SET_ACTUAL_VERSION](state, value) {
    state.actualVersion = value;
  },
  [mt.SET_CMS_VERSION](state, value) {
    state.cmsVersion = value;
  },
  [mt.SET_APP_VERSION](state, value) {
    state.appVersion = value;
  },
};
